import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './Dashboard';
import DriversPage from './DriversPage';
import SettledDrivers from './components/SettledDrivers';
import LoginPage from './components/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import AdminApprovals from './AdminApprovals';
import { SocketProvider } from './context/SocketContext';
import { AuthProvider } from './context/AuthContext';

function App() {
  const [currentPage, setCurrentPage] = useState('Dashboard');

  return (
    <AuthProvider>
      <SocketProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={
                <Layout currentPage={currentPage} setCurrentPage={setCurrentPage}>
                  {currentPage === 'Dashboard' && <Dashboard />}
                  {currentPage === 'Payouts' && <DriversPage />}
                  {currentPage === 'History' && <SettledDrivers />}
                  {currentPage === 'Admins' && <AdminApprovals />}
                  {/* Placeholder for other pages */}
                  {currentPage !== 'Dashboard' && currentPage !== 'Payouts' && currentPage !== 'History' && currentPage !== 'Admins' && (
                    <div className="flex items-center justify-center h-[60vh]">
                      <p className="text-[#909090] font-medium text-xl">{currentPage} Module - Coming Soon</p>
                    </div>
                  )}
                </Layout>
              } />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </SocketProvider>
    </AuthProvider>
  );
}

export default App;